import _ from 'lodash';
import { STOP_CONSULTATION } from 'modules/conference/actions/stopConsultation';
import { isCurrentConversationMCU } from 'modules/appointmentInfo/selectors/currentAppointment';
import { conferenceInProgress, conferenceStopping } from 'modules/conference/selectors/consultationInfo';
import { setConversationInProgress } from 'modules/conference/actions/_newConversationActions/conversationLifecircleActions';

import { setVideoLayout } from './setVideoLayout';
import { SAVE_LOCAL_VIDEO } from './startConsultation';
import { BROADCAST_RECONNECT } from './videoConsultation';
import { needToBeStandardVideoLayout } from '../selectors/connectionStatus';
import { checkConnectionEstablished, checkReconnectionStatus } from './consultationLifecycle';
import { setUpstreamConnectionStatus, setDownstreamConnectionStatus } from './setConnectionStatus';
import { CONSULTATION_WILL_START, REMOTE_CLIENT_WILL_JOIN } from '../constants/consultationActionTypes';
import {
  setRemoteVideo,
  onRemoteAudioDisable,
  onRemoteAudioEnable,
  onRemoteVideoDisable,
  onRemoteVideoEnable,
} from './remoteMedia';


export const onMessage = (client, payload) => (dispatch, getState) => {
  const state = getState();
  const userId = client.getUserId();
  const remoteVideoDisabled = state.conference.remoteMedia.videoDisabled;
  const remoteAudioDisabled = state.conference.remoteMedia.audioDisabled;
  const userRole = client.getRoles()[0];
  const userName = client.getUserAlias();
  const isGuest = userRole === 'guest';

  if (_.has(payload, 'audioDisabled') && (remoteAudioDisabled !== payload.audioDisabled || isGuest)) {
    return payload.audioDisabled
      ? dispatch(onRemoteAudioDisable(userName, isGuest))
      : dispatch(onRemoteAudioEnable(userName, isGuest));
  }

  if (_.has(payload, 'videoDisabled') && (remoteVideoDisabled !== payload.videoDisabled || isGuest)) {
    return payload.videoDisabled
      ? dispatch(onRemoteVideoDisable(userName, isGuest))
      : dispatch(onRemoteVideoEnable(userName, isGuest));
  }

  if (_.has(payload, 'reconnect')) {
    return dispatch({
      type: BROADCAST_RECONNECT,
      payload: { userId },
    });
  }

  if (_.has(payload, 'consultationEnd') && conferenceInProgress(state) && !conferenceStopping(state)) {
    return dispatch({ type: STOP_CONSULTATION.pending });
  }
};

export const upstreamStateChange = (payload) => (dispatch, getState) => {
  if (isCurrentConversationMCU(getState())) return;
  dispatch({
    type: SAVE_LOCAL_VIDEO,
    payload: { localVideo: (payload.getState() === 4) },
  });

  if (needToBeStandardVideoLayout(payload.getState())) {
    dispatch(setVideoLayout(false));
  }

  dispatch(setUpstreamConnectionStatus(4));

  dispatch(checkReconnectionStatus());
};

export const downstreamStateChange = (payload) => (dispatch, getState) => {
  const hasConnected = (payload.getState() === 4);

  dispatch(setDownstreamConnectionStatus(payload.getState()));

  dispatch(setRemoteVideo(hasConnected));

  if (needToBeStandardVideoLayout(payload.getState())) {
    dispatch(setVideoLayout(false));
  }

  if (hasConnected) {
    dispatch({ type: REMOTE_CLIENT_WILL_JOIN });
    dispatch({ type: CONSULTATION_WILL_START });
  }

  if (isCurrentConversationMCU(getState())) return;

  dispatch(checkConnectionEstablished());
  dispatch(checkReconnectionStatus());
};

export const downstreamStateChangeSIP = (payload) => (dispatch) => {
  const hasConnected = payload.getState() === 4;

  dispatch(setDownstreamConnectionStatus(payload.getState()));

  dispatch(setRemoteVideo(hasConnected));

  if (needToBeStandardVideoLayout(payload.getState())) {
    dispatch(setVideoLayout(false));
  }

  if (hasConnected) {
    dispatch({ type: REMOTE_CLIENT_WILL_JOIN });
    dispatch({ type: CONSULTATION_WILL_START });
  }

  dispatch(checkConnectionEstablished());
};

// export const remoteClientJoin = () => setConversationInProgress();

export const onMcuVideoLayoutChange = participantsCount => (dispatch) => {
  const hasConnected = (participantsCount > 1);
  const downstreamState = hasConnected ? 4 : 8;

  dispatch(setDownstreamConnectionStatus(downstreamState));

  dispatch(setRemoteVideo(hasConnected));

  if (needToBeStandardVideoLayout(downstreamState)) {
    dispatch(setVideoLayout(false));
  }

  if (hasConnected) {
    dispatch({ type: CONSULTATION_WILL_START });
  }

  dispatch(checkConnectionEstablished());
  dispatch(checkReconnectionStatus());
};
